/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  users: [],
  limit: 5,
  keywordFilter: '',
};

const getters = {
  users: state => state.users,
  limit: state => state.limit,
  keywordFilter: state => state.keywordFilter,
};

const actions = {
  fetch({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    let keyword = '';
    const orderBy = payload.orderBy ? `&orderBy=${payload.orderBy}` : '';
    let partner = '';
    if (payload.keyword) {
      commit(mTypes.SET_KEYWORD_FILTER, payload.keyword);
      keyword = `&q=${payload.keyword}`;
    }
    if (payload.partnerId != null) {
      partner = `&partnerId=${payload.partnerId}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/users/list?${keyword}${limit}${partner}${orderBy}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, users) {
    state.users = users.data;
  },
  [mTypes.EDIT_DATA](state, updatedUser) {
    const index = state.users.items.findIndex(obj => obj.id === updatedUser.id);
    if (index !== -1) {
      state.users.items[index] = updatedUser;
    } else {
      state.users.items.unshift(updatedUser);
    }
  },
  [mTypes.SET_LIMIT](state, limit) {
    state.limit = limit;
  },
  [mTypes.CLEAR_STATE](state) {
    state.users = {};
  },
  [mTypes.REMOVE_DATA](state, userId) {
    const index = state.users.items.findIndex(obj => obj.id === userId);
    state.users.items.splice(index, 1);
    state.users.total -= 1;
  },
  [mTypes.REMOVE_DATAS](state, ids) {
    const items = state.users.items.filter((obj) => {
      const findItem = ids.find(id => id === obj.id);

      if (findItem) return false;
      return true;
    });

    state.users.items = items;
  },
  [mTypes.SET_KEYWORD_FILTER](state, keywordFilter) {
    state.keywordFilter = keywordFilter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/users.js